<template>
  <div class="mobile__user__menu" @click="$emit('close')">
    <ul>
      <router-link :to="{name: 'UserSaved'}">
        <li>
          <span>{{ $t('user.save') }}</span>
        </li>
      </router-link>
      <router-link :to="{name: 'UserHistory'}">
        <li>
          <span>{{ $t('user.orders') }}</span>
        </li>
      </router-link>
      <router-link :to="{name: 'UserPoints'}">
        <li>
          <span>{{ $t('user.discount') }}</span>
        </li>
      </router-link>
      <router-link :to="{name: 'UserInfo'}">
        <li>
          <span>{{ $t('user.info') }}</span>
        </li>
      </router-link>
      <hr class="border-b border-grey-lightest m-0 p-0">
    <li @click="logoutHandler">
      <div class="text-center">{{ $t('logout') }}</div>
    </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'mobileUserMenu',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    ...mapActions({
      goLogout: 'user/goLogout'
    }),
    logoutHandler: function () {
      this.goLogout()
    }
  }
}
</script>

<style lang="sass" scoped>
.mobile__user__menu
  ul
    @apply list-reset
    a
      @apply no-underline
    li
      @apply text-grey-darker py-16 px-8
      &:hover
        @apply text-blue
</style>
